import { render, staticRenderFns } from "./Periodo.vue?vue&type=template&id=26eaa2af&scoped=true"
import script from "./Periodo.vue?vue&type=script&lang=js"
export * from "./Periodo.vue?vue&type=script&lang=js"
import style0 from "./Periodo.vue?vue&type=style&index=0&id=26eaa2af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eaa2af",
  null
  
)

export default component.exports